import { Controller, type ControllerProps, useFormContext } from 'react-hook-form';
import { TextField as UiTextField, type TextFieldProps as UiTextFieldProps } from 'ui';

export type TextFieldProps = Omit<UiTextFieldProps, 'name'> & {
  'data-testid'?: string;
  name: string;
  rules?: ControllerProps['rules'];
};

export const TextField = ({
  name,
  label,
  placeholder,
  onBlur,
  required = false,
  disabled = false,
  'data-testid': dataTestId,
  helperText,
  size = 'small',
  rules = {},
  onChange,
  ...rest
}: TextFieldProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      rules={{
        ...(required && { required: 'This field is required' }),
        ...rules,
      }}
      control={control}
      render={({ field, fieldState }) => {
        const { error } = fieldState;
        return (
          <UiTextField
            fullWidth
            required={required}
            label={label}
            id={name}
            placeholder={placeholder}
            error={Boolean(error)}
            helperText={error?.message || helperText}
            value={field.value ?? ''}
            onChange={(event) => {
              field.onChange(event.target.value);
              onChange?.(event);
            }}
            name={name}
            inputRef={field.ref}
            {...(onBlur && { onBlur })}
            disabled={disabled}
            size={size}
            inputProps={{
              'data-testid': dataTestId,
            }}
            {...rest}
          />
        );
      }}
    />
  );
};
